import React from "react";
import { closeicon } from "assets/icons/index";
import { useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import { Spin } from "antd";
import { useTranslation } from "react-i18next";

interface ResetPasswordMethodProps {
  activePop: string;
  setActivePop: React.Dispatch<React.SetStateAction<string>>;
  resetPasswordMethod: number;
  setResetPasswordMethod: React.Dispatch<React.SetStateAction<number>>;
}

const ResetPasswordMethod = ({
  activePop,
  setActivePop,
  resetPasswordMethod,
  setResetPasswordMethod,
}: ResetPasswordMethodProps) => {
  const { t, i18n } = useTranslation();
  return (
    <section
      data-aos="zoom-out"
      data-aos-duration="400"
      className="fixed top-0 right-0 w-full h-screen bg-black/75 flex items-center justify-center z-10"
    >
      <div
        className={`relative lg:w-[410px] p-[30px] rounded-[15px] flex flex-col gap-[25px] ${
          i18n.language === "en" ? "font-Poppins" : "font-Almarai"
        } bg-white`}
      >
        {/*************************** top title section  **************/}
        <div className="relative flex items-center justify-between">
          <div></div>
          {/* Reset Password */}
          <div className="font-[700] text-[24px] text-second_color flex items-center justify-center">
            {t("Reset Password")}
          </div>

          {/* close button */}
          <div className="cursor-pointer" onClick={() => setActivePop("")}>
            <img src={closeicon} alt="logo" />
          </div>
        </div>

        {/*************************** instructions ***************************/}
        <div className="text-[16px] font-[600] text-second_color flex items-center justify-center">
          {t("How do you want to reset your password?")}
        </div>

        {/*************************** options section  **************/}
        <div className="flex items-center gap-10">
          {/* by phone  */}
          <div className="w-full flex items-center justify-center">
            <button
              onClick={() => {
                setActivePop("generateOtpResetPassword");
                setResetPasswordMethod(1);
              }}
              className="w-[120px] h-[40px] bg-[#DCDEE3] text-first_color text-[16px] rounded-[15px] hover:text-white hover:bg-first_color duration-300 font-[600]"
            >
              {t("Phone")}
            </button>
          </div>

          {/* by email  */}
          <div className="w-full flex items-center justify-center">
            <button
              onClick={() => {
                setActivePop("generateOtpResetPassword");
                setResetPasswordMethod(2);
              }}
              className="w-[120px] h-[40px] bg-[#DCDEE3] text-first_color text-[16px] rounded-[15px] hover:text-white hover:bg-first_color duration-300 font-[600]"
            >
              {t("Email")}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPasswordMethod;
